import { type PageOpenedEvent, TrackedLoadedPageName } from "./PageOpened";
import type { SearchSuggestionTappedEvent } from "./SearchedSuggestionTapped";
import { TrackingEventName } from "./TrackingEventName";
import type { ViewedWebviewEvent } from "./ViewedWebviewEvent";

export const CommonEventName = {
  ...TrackingEventName,
};

export type { PageOpenedEvent };

export type CommonCoreEvent =
  | ViewedWebviewEvent
  | SearchSuggestionTappedEvent
  | PageOpenedEvent;

export { TrackedLoadedPageName };
